import { StaffSelection } from "@/components/CommisstionSetting/StaffSelection";
import { setSettingByKey } from "@/features/commissionSlice";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import _ from "lodash";
import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

const MemoSpecialCommissionLevelFormRow = React.memo(
  function SpecialCommissionLevelFormRow({
    index,
    item,
    validations,
    disabled,
    removeFormData,
    handleFormData,
  }) {
    return (
      <Stack
        sx={{ my: 2 }}
        key={index}
        direction={"row"}
        divider={<Divider orientation="vertical" flexItem variant="middle" />}
        spacing={5}
      >
        <Box sx={{ flex: 3, display: "flex", justifyContent: "center" }}>
          <TextField
            disabled={disabled}
            error={!!validations[index]?.amountErr}
            helperText={validations[index]?.amountErr}
            sx={{ maxWidth: 380, minWidth: 100 }}
            value={item.amount}
            type="number"
            id="outlined-basic"
            label="銷售額"
            variant="outlined"
            onChange={(event) =>
              handleFormData(index, "amount", Math.abs(event.target.value))
            }
            InputProps={{
              inputProps: {
                min: 0,
              },
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
        </Box>
        <Box sx={{ flex: 2, display: "flex", justifyContent: "center" }}>
          <TextField
            disabled={disabled}
            error={!!validations[index]?.percentageErr}
            helperText={validations[index]?.percentageErr}
            sx={{ maxWidth: 180, minWidth: 100 }}
            value={item.percentage}
            type="number"
            id="outlined-basic"
            label="百份比"
            variant="outlined"
            onChange={(event) => {
              handleFormData(index, "percentage", event.target.value);
            }}
            InputProps={{
              inputProps: {
                min: 0,
              },
              startAdornment: (
                <InputAdornment position="start">%</InputAdornment>
              ),
            }}
          />
        </Box>
        {!disabled && (
          <Stack
            direction={"row"}
            justifyContent="space-between"
            alignItems={"flex-start"}
            sx={{ flex: 1 }}
          >
            <IconButton color="error" onClick={() => removeFormData(index)}>
              <DeleteForeverIcon></DeleteForeverIcon>
            </IconButton>
          </Stack>
        )}
      </Stack>
    );
  },
  (prev, next) => {
    return (
      next.index === prev.index &&
      _.isEqual(prev.item, next.item) &&
      _.isEqual(prev.validations, next.validations)
    );
  },
);

export default function SpecialCommissionLevelFormRows({
  disabled,
  promoterOption,
}) {
  const dispatch = useDispatch();

  const specialCommissionLevels = useSelector(
    (state) => state.commission.settings.specialCommissionLevels,
    shallowEqual,
  );

  const validations = useSelector(
    (state) => state.commission.validations.specialCommissionLevels,
    shallowEqual,
  );

  const removeFormData = React.useCallback(
    async (index) => {
      const cloneRow = _.cloneDeep(specialCommissionLevels);
      cloneRow.schmea.splice(index, 1);
      dispatch(
        setSettingByKey({
          key: "specialCommissionLevels",
          value: cloneRow,
        }),
      );
    },
    [dispatch, specialCommissionLevels],
  );
  const handlePromoterFormData = React.useCallback(
    async (value) => {
      const cloneRow = _.cloneDeep(specialCommissionLevels);
      cloneRow.promoter = value;
      dispatch(
        setSettingByKey({
          key: "specialCommissionLevels",
          value: cloneRow,
        }),
      );
    },
    [dispatch, specialCommissionLevels],
  );
  const handleSchmeaFormData = React.useCallback(
    async (position, key, value) => {
      const cloneRow = _.cloneDeep(specialCommissionLevels);
      cloneRow.schmea[position][key] = value;
      dispatch(
        setSettingByKey({
          key: "specialCommissionLevels",
          value: cloneRow,
        }),
      );
    },
    [dispatch, specialCommissionLevels],
  );
  const createFormData = React.useCallback(() => {
    const cloneRow = _.cloneDeep(specialCommissionLevels);
    cloneRow.schmea.push({});
    dispatch(
      setSettingByKey({
        key: "specialCommissionLevels",
        value: cloneRow,
      }),
    );
  }, [dispatch, specialCommissionLevels]);
  return (
    <React.Fragment>
      <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
        <StaffSelection
          formDetail={specialCommissionLevels}
          handlePromoterFormData={handlePromoterFormData}
          staffOptions={promoterOption}
        ></StaffSelection>
      </Box>
      {_.map(specialCommissionLevels?.schmea, (item, index) => (
        <React.Fragment>
          <MemoSpecialCommissionLevelFormRow
            item={item}
            index={index}
            validations={validations}
            disabled={disabled}
            removeFormData={removeFormData}
            handleFormData={handleSchmeaFormData}
          ></MemoSpecialCommissionLevelFormRow>
        </React.Fragment>
      ))}
      {!disabled && (
        <Box>
          <IconButton component="label" onClick={createFormData}>
            <AddBoxOutlinedIcon />
          </IconButton>
        </Box>
      )}
    </React.Fragment>
  );
}
